import React, {useState} from 'react';
import styleImage from'./image.module.css'
const Image = ({src,style,alt="media"}) => {
    const [isOpen, setIsOpen] = useState(false);

    const onClickHandler = () => {
        setIsOpen(prev => !prev)
    }
    const onImageClick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsOpen(false); // Закрываем изображение при клике на нем
    };
    return (
        <>
            <img src={src} alt={alt}
                 style={style}
                 onClick={() => onClickHandler()}
                 className={styleImage.image}
            />
            {isOpen &&
            <div className={styleImage.overlay} onClick={() => onClickHandler()}>
                <div className={styleImage.imageContainer}>
                    <img src={src} alt={alt}
                         onClick={(e) => onImageClick(e)} // Добавляем новую функцию-обработчик
                         className={styleImage.bigImage}
                    />
                </div>
            </div>}
        </>
    );
}

export default Image;